import $ from 'jquery';
import { AI_FEATURE_CATEGORIES, getAllFeatures } from './aiFeatureCategories';
import { initAiCreditPackagesModal } from '../../sidebar/initAiCreditPackagesModal';

let currentView = 'list'; // 'list' or 'detail'
let previousFeatureId = null;

/**
 * Show the tour list view
 */
function showTourList() {
  currentView = 'list';

  // Remove back button if it exists
  $('.ai-tour-back-btn').remove();

  // Show the tour modal
  $('#aiGuidedTourModal').modal('show');

  // Prevent ESC key from propagating to global handlers
  $('#aiGuidedTourModal').on('keydown.aiModal', function (e) {
    if (e.keyCode === 27) {
      e.stopPropagation();
    }
  });

  // Clean up event handler when modal is hidden
  $('#aiGuidedTourModal').on('hidden.bs.modal.aiModal', function () {
    $(this).off('keydown.aiModal');
    $(this).off('hidden.bs.modal.aiModal');
  });

  // Reset scroll position when modal is shown
  $('#aiGuidedTourModal').on('shown.bs.modal', function () {
    $('#aiGuidedTourModal .modal-body').scrollTop(0);
  });
}

/**
 * Generate HTML for a single tour item
 */
function generateTourItemHTML(feature) {
  return `
    <div class="ai-tour-item" data-feature-id="${feature.id}">
      <img 
        src="${feature.image}" 
        alt="${feature.title}" 
        class="ai-tour-icon"
      />
      <div class="ai-tour-title">${feature.title}</div>
      <div class="ai-tour-hover-text">
        <div>
          <div class="mb-2">Scopri</div>
          <div class="h5 mb-2">${feature.title}</div>
          <div style="font-size: 0.9rem; font-weight: 400;">Clicca per vedere come funziona</div>
        </div>
        <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16" style="position: absolute; bottom: 20px; right: 20px;">
          <path fill-rule="evenodd" d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8zm15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H4.5z"/>
        </svg>
      </div>
    </div>
  `;
}

/**
 * Generate HTML for the tour grid view
 */
function generateTourGridHTML() {
  let html = '';

  AI_FEATURE_CATEGORIES.forEach((category) => {
    html += `
      <div class="ai-tour-category">
        ${category.title}
      </div>
      <div class="ai-tour-grid">
        ${category.features
          .map((feature) => generateTourItemHTML(feature))
          .join('')}
      </div>
    `;
  });

  return html;
}

/**
 * Show specific feature detail
 */
function showFeatureDetail(featureId) {
  const feature = getAllFeatures().find((f) => f.id === featureId);
  if (!feature) return;

  previousFeatureId = featureId;
  currentView = 'detail';

  // Hide the tour modal
  $('#aiGuidedTourModal').modal('hide');

  // Show the feature detail modal
  $('#aiFeatureDetailTitle').text(feature.title);
  $('#aiFeatureDetailDescription').text(feature.description);

  // Update highlight text
  if (feature.highlightText) {
    $('#aiFeatureDetailHighlightText').text(feature.highlightText);
    $('#aiFeatureDetailTagline').show();
  } else {
    $('#aiFeatureDetailTagline').hide();
  }

  // Show before/after images
  const beforeSrc = feature.beforeImg || '';
  const afterSrc = feature.afterImg || '';

  $('#aiFeatureDetailBeforeImg').attr('src', beforeSrc).show();
  $('#aiFeatureDetailAfterImg').attr('src', afterSrc).show();

  // Set animated comparison images
  $('#animatedBeforeImg').attr('src', beforeSrc);
  $('#animatedAfterImg').attr('src', afterSrc);

  // Populate FAQ section
  const $faqContainer = $('#aiFeatureDetailFAQ');
  const $faqSection = $('#aiFeatureDetailFAQSection');
  $faqContainer.empty();

  if (feature.faq && feature.faq.length > 0) {
    // Show FAQ section
    $faqSection.show();

    feature.faq.forEach((faq, index) => {
      const faqItem = $(`
        <div class="faq-item">
          <button class="faq-question" data-faq-index="${index}">
            ${faq.question}
          </button>
          <div class="faq-answer" id="faq-answer-${index}">
            <p>${faq.answer}</p>
          </div>
        </div>
      `);
      $faqContainer.append(faqItem);
    });

    // Handle FAQ accordion functionality
    $('.faq-question')
      .off('click')
      .on('click', function () {
        const $this = $(this);
        const $answer = $this.next('.faq-answer');

        // Toggle current answer
        $this.toggleClass('active');
        $answer.toggleClass('show');

        // Close other answers
        $('.faq-question').not($this).removeClass('active');
        $('.faq-answer').not($answer).removeClass('show');
      });
  } else {
    // Hide FAQ section if no FAQs
    $faqSection.hide();
  }

  // Add back button to modal footer (left of Acquista Crediti)
  if (!$('#aiFeatureDetailModal .ai-tour-back-btn').length) {
    const backButton = `
      <button class="ai-tour-back-btn btn btn-secondary">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16" class="mr-1">
          <path fill-rule="evenodd" d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8z"/>
        </svg>
        Torna al Tour
      </button>
    `;

    // Insert before the Acquista Crediti button
    $('#aiFeatureDetailModal .modal-footer').prepend(backButton);
  }

  // Handle back button click
  $('.ai-tour-back-btn')
    .off('click')
    .on('click', function (e) {
      e.preventDefault();
      $('#aiFeatureDetailModal').modal('hide');
      setTimeout(() => {
        showTourList();
      }, 300);
    });

  // Ensure buy credits button opens packages modal
  $('#aiFeatureDetailModal [data-sidebar-action="buy-ai-credits"]')
    .off('click.modalBuyCredits')
    .on('click.modalBuyCredits', async function (e) {
      e.preventDefault();
      e.stopPropagation();
      try {
        $('#aiFeatureDetailModal').modal('hide');
      } catch (err) {
        console.error('Failed to hide AI feature detail modal', err);
      }
      try {
        initAiCreditPackagesModal();
      } catch (err) {
        console.error('Failed to initialize AI credit packages modal', err);
      }
      try {
        const $ = window.jQuery || window.$;
        if ($) $('#aiCreditPackagesModal').modal('show');
      } catch (err) {
        console.error('Failed to show #aiCreditPackagesModal', err);
      }
    });

  // Show the detail modal
  $('#aiFeatureDetailModal').modal('show');

  // Prevent ESC key from propagating to global handlers
  $('#aiFeatureDetailModal').on('keydown.aiModal', function (e) {
    if (e.keyCode === 27) {
      e.stopPropagation();
    }
  });

  // Clean up event handler when modal is hidden
  $('#aiFeatureDetailModal').on('hidden.bs.modal.aiModal', function () {
    $(this).off('keydown.aiModal');
    $(this).off('hidden.bs.modal.aiModal');
  });

  // Scroll to top when modal is shown
  $('#aiFeatureDetailModal').on('shown.bs.modal', function () {
    $('#aiFeatureDetailModal .modal-body').scrollTop(0);
  });
}

/**
 * Initialize the guided tour functionality
 */
export function initAiGuidedTour() {
  // Generate and insert the tour content
  const tourHTML = generateTourGridHTML();
  $('#aiGuidedTourContent').html(tourHTML);

  // Remove existing listeners to prevent duplicates
  $('body').off('click.aiGuidedTour');
  $('#aiFeatureDetailModal').off('hidden.bs.modal.aiGuidedTour');

  // Handle tour button click with namespaced event
  $('body').on('click.aiGuidedTour', '#ai-guided-tour-btn', function (e) {
    e.preventDefault();
    showTourList();
  });

  // Handle tour item clicks with namespaced event
  $('body').on('click.aiGuidedTour', '.ai-tour-item', function (e) {
    e.preventDefault();
    const featureId = $(this).data('feature-id');
    showFeatureDetail(featureId);
  });

  // Handle modal hidden event to check if we should return to tour
  $('#aiFeatureDetailModal').on('hidden.bs.modal.aiGuidedTour', function () {
    // Only return to tour if we came from tour and back button wasn't clicked
    if (currentView === 'detail' && previousFeatureId) {
      // Reset state
      currentView = 'list';
      previousFeatureId = null;
    }
  });
}
